<template>
	<div class="view">
		<div class="left" @mouseover="select('left')" @mouseout="select(null)" @click="open('/articles')">
			<div class="bg">
				<div class="bg-mask"></div>
			</div>

			<div style="z-index: 5">
				<div class="title">Интервью</div>
				<div class="text">Тату-мастер Олег Турянский рассказал нам о трендах, терпении и выносе мозга.</div>

				<router-link to="/select">
					<uiButton :color="selected === 'left' ? 'dark' : 'light'">Читать</uiButton>
				</router-link>
			</div>
		</div>

		<div
			class="right"
			@mouseover="select('right')"
			@mouseout="select(null)"
			@click="open('/contest')"
		>
			<div class="bg">
				<div class="bg-mask"></div>
			</div>
			<div style="z-index: 5">
				<div class="title">Конкурс</div>
				<div
					class="text"
				>Получите татуировку от мастера, сделанную по индивидуальному эскизу, бесплатно!</div>
				<router-link to="/select">
					<uiButton :color="selected === 'right' ? 'dark' : 'light'">Участовать</uiButton>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Select',
	data() {
		return {
			selected: null,
		}
	},
	methods: {
		open(type) {
			ga('send', 'event', 'select-open', type)
			this.$router.push(type)
		},
		select(id) {
			if (window.innerWidth < 900) return
			this.selected = id
		},
	}
}
</script>

<style lang="less" scoped>
@import "../styles.less";

.view {
	display: flex;
}

.left,
.right {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 50vw;
	height: 100vh;
	position: relative;
	cursor: pointer;

	.bg {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 0;
		background-size: cover;

		.bg-mask {
			width: 100%;
			height: 100%;
			position: absolute;
			background: @color-main;
			opacity: 0;
			transition: all 300ms ease;
		}
	}

	&:hover {
		.bg .bg-mask {
			opacity: 0.9;
		}

		.text,
		.title {
			color: #000;
		}
	}
}

.left .bg {
	background-image: url("../assets/photos/select1.jpg");
}

.right .bg {
	background-image: url("../assets/photos/select2.jpg");
}

.title {
	font-size: 32px;
	font-weight: bold;
	margin-top: 60px;
	margin-bottom: 30px;
	text-transform: uppercase;
	font-family: @font-title;
	transition: all 300ms ease;
}

.text {
	font-size: 18px;
	width: 96%;
	max-width: 480px;
	line-height: 30px;
	transition: all 300ms ease;
	margin-bottom: 30px;
}

@media (max-width: 900px) {
	.view {
		flex-direction: column;
	}

	.left,
	.right {
		width: 100vw;
		height: 50vh;

		.bg {
		}
	}

	.title {
		margin-top: 0px;
		margin-bottom: 10px;
	}

	.text {
		font-size: 16px;

		max-width: 80%;
		margin: 0 auto;
		margin-bottom: 20px;
		line-height: 20px;
	}
}
</style>
